import { useCallback, useContext, useEffect, useState } from 'react';
import { gql } from '@apollo/client';
import GqlClientContext from '../contexts/GqlClientContext';
import CurrentUserContext from '../contexts/CurrentUserContext';

const query = {
  query: gql`
    query getFieldDefinitions {
      getFieldDefinitions {
        fieldType
        aggFuncs
      }
    }
  `,
};

const useFieldAggFuncDefinitions = () => {
  const { isWallboardUser } = useContext(CurrentUserContext);
  const { client } = useContext(GqlClientContext);
  const [fieldAggFuncDefinitions, setFieldAggFuncDefinitions] = useState<
    FleetOps.FieldAggFuncDefinition[]
  >(window.emptyArray);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getDefinitions = useCallback(() => {
    if (isWallboardUser) {
      setFieldAggFuncDefinitions(window.emptyArray);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    client.query(query).then((response) => {
      const newDefs = response.data
        .getFieldDefinitions as FleetOps.FieldAggFuncDefinition[];
      setFieldAggFuncDefinitions(newDefs);
      setIsLoading(false);
    });
  }, [client, isWallboardUser]);

  useEffect(() => {
    if (fieldAggFuncDefinitions.length === 0) {
      const i = setInterval(getDefinitions, 2000);
      return () => {
        clearInterval(i);
      };
    }
  }, [fieldAggFuncDefinitions.length, getDefinitions, isWallboardUser]);

  return {
    isLoading,
    fieldAggFuncDefinitions,
  };
};

export default useFieldAggFuncDefinitions;
